import { resolveComponentVariant } from '../componentContract'
import { BoardChip } from '../../boardui/Chip'

const tones = ['neutral', 'info', 'success', 'warning', 'danger']

export function Badge({ tone = 'neutral', compact = false, children, className = '', title }) {
  const resolvedTone = resolveComponentVariant('Badge tone', tone, tones, 'neutral')
  return (
    <BoardChip title={title} tone={resolvedTone} compact={compact} className={className}>
      {children}
    </BoardChip>
  )
}
